import React from 'react';
import { H2Alt, SecondaryH6 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';
import Aside from './Aside';

function Article({
  asideTitle,
  title,
  lastUpdated,
  anchorTagText,
  asideBody,
  children
}) {
  return (
    <div className={styles.container}>
      <ArticleSection
        title={title}
        lastUpdated={lastUpdated}
        className={styles.article}
      >
        {children}
      </ArticleSection>

      <Aside
        className={styles.aside}
        asideTitle={asideTitle}
        anchorTagText={anchorTagText}
        asideBody={asideBody}
      />
    </div>
  );
}

const ArticleSection = ({ title, lastUpdated, children, ...rest }) => {
  return (
    <div className={margin.top_md} {...rest}>
      {title && (
        <H2Alt tag="h1" marginClass={margin.bottom_md}>
          {title}
        </H2Alt>
      )}
      {!!lastUpdated && (
        <SecondaryH6 uppercase tag="div" marginClass={margin.bottom_md}>
          Last Updated {lastUpdated}
        </SecondaryH6>
      )}
      {children}
    </div>
  );
};

export default Article;
export { ArticleSection };
